




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { PreCollectionsParams } from '@/resource/pre-collection/pre-collection.store';
import { dragscroll } from 'vue-dragscroll';
import {
  PreCollectionSortBy,
  PreCollectionType,
} from '@/resource/pre-collection/pre-collection.model';
import { SubjectType } from '@/resource/subject/subject.model';

@Component({
  components: {},
  directives: {
    dragscroll,
  },
})
export default class PreCollectionHighlight extends Vue {
  @Prop({ required: true })
  queries: PreCollectionsParams;

  collections = [
    {
      name: 'Percubaan SPM',
      url: 'browse?subject=all&keyword=percubaan%20spm',
      queries: {
        subjectUuid: 'all',
        keyword: 'percubaan spm',
        subjectType: SubjectType.All,
        sortBy: PreCollectionSortBy.Latest,
        preCollectionTypes: [
          PreCollectionType.Exam,
          PreCollectionType.Practice,
          PreCollectionType.Course,
        ],
        years: [],
        levels: [],
      },
    },
    {
      name: 'Latihan Topikal',
      url: 'browse?subject=all&paper=practice',
      queries: {
        subjectUuid: 'all',
        keyword: '',
        subjectType: SubjectType.All,
        sortBy: PreCollectionSortBy.Latest,
        preCollectionTypes: [PreCollectionType.Practice],
        years: [],
        levels: [],
      },
    },
    {
      name: 'Speaking Test SPM',
      url: 'browse?subject=all&keyword=speaking',
      queries: {
        subjectUuid: 'all',
        keyword: 'speaking',
        subjectType: SubjectType.All,
        sortBy: PreCollectionSortBy.Latest,
        preCollectionTypes: [
          PreCollectionType.Exam,
          PreCollectionType.Practice,
          PreCollectionType.Course,
        ],
        years: [],
        levels: [],
      },
    },
    {
      name: 'Ujian Bertutur SPM',
      url: 'browse?subject=all&keyword=bertutur',
      queries: {
        subjectUuid: 'all',
        keyword: 'bertutur',
        subjectType: SubjectType.All,
        sortBy: PreCollectionSortBy.Latest,
        preCollectionTypes: [
          PreCollectionType.Exam,
          PreCollectionType.Practice,
          PreCollectionType.Course,
        ],
        years: [],
        levels: [],
      },
    },
  ];

  selectKeyword(collection: { name: string; url: string; queries: any }) {
    this.$sendMpEvent({
      event: this.$mp_value.PremadeHighlightClick,
      properties: {
        ...collection,
      },
    });

    if (this.$route.name === 'browse') {
      Object.keys(collection.queries).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(this.queries, key)) {
          this.queries[key] = collection.queries[key];
        }
      });

      this.$emit('reFetch', true);
    }

    if (this.$route.path === '/') {
      this.$router.push({ path: collection.url });
    }
  }
}
